import http from '@/utils/http'

// const token = jhsapp.getToken() || '';

// 卡片信息
interface CardInfo {
  image_url: string
  count: number
}

// 卡组卡片统计
interface MarketDeckCard {
  name: string
  card_sum_count: number
  cards: CardInfo[]
}

export interface MarketDeckResponse {
  appId: string
  avatar: string
  desc: string | null
  favorite_count: number
  game_key: string
  image_url: string
  jsApiList: string[]
  like_count: number
  market_deck_cards: MarketDeckCard[]
  market_deck_desc: string | null
  market_deck_environment_name: string
  market_deck_image: string
  market_deck_name: string
  merge_display: number
  nonceStr: string
  openTagList: string[]
  open_app_url: string
  signature: string
  timestamp: number
  title: string
  url: string
  username: string
}

// 榜单
export const getRank = () => {
  return http.get('/ranking/searchPageRanking');
};

// 卡组分享落地页
export const getMarketDeck = (params: {
  market_deck_uuid: string
  url: string
}) => {
  return http.get<MarketDeckResponse>('/share/market-deck', params)
}

// 返回 EVONET 公钥
export const getKvonetKey = (params: Record<string, any>) => {
  return http.get<string>('/evonet/key', params)
}

// 新增 EVONET 支付方式
// export const evonetPayment = (params: Record<string, any>) => {
//   return http.post<string>('/evonet/payment', params, {
//     headers: {
//       Authorization: `Bearer ${token}`
//     }
//   })
// }

// token已在http中增加了
export const evonetPayment = (params: Record<string, any>) => {
  return http.post<string>('/evonet/payment', params)
}

// 获取配置文件数据
export const getSecondaryConfig = (): Promise<Record<string, any>> => {
  const isIntl = __IS_INTL__;
  const isProd = __ENV__ === 'prod';

  console.log(`Environment: ${__ENV__}, Region: ${__REGION__}, IsIntl: ${isIntl}`);

  const testurl = !isProd ? '/secondary_config_test.json' : '/secondary_config.json';
  // const baseUrl = isIntl
  //   ? 'https://files.tcgcard.jp/configs'
  //   : 'https://jihuanshe-qn-src.jihuanshe.com/configs';

  const baseUrl = !isIntl ? 'https://jihuanshe-qn-src.jihuanshe.com/configs' : isProd ? 'https://files.tcgasset.com/configs' : 'https://files.tcgcard.jp/configs';

  const prefixUrl = isIntl ? '/config/jp/jp' : '';


  const url = `${baseUrl}${prefixUrl}${testurl}`;

  return http.get<Record<string, any>>(url);
};

// 获取卡包分享数据
export const getPackShareData = (params: {
  pack_id: string | number;
  game_key: string;
  game_sub_key: string;
  url: string;
}) => {
  return http.get<any>('/share/pack', params);
};

// 获取卡牌分享数据
export const getCardShareData = (params: {
  cvid: string | number;
  game_key: string;
  game_sub_key: string;
  url: string;
}) => {
  return http.get<any>('/share/card', params);
};

/**
 * 获取卡片详情
 * @param {Object} params
 * @param {string} params.game_key - 游戏key
 * @param {string} params.game_sub_key - 游戏子key
 * @param {string} params.cvid - 卡片ID
 */
export function getCardDetail(params: {
  game_key: string;
  game_sub_key: string;
  cvid: string;
}) {
  return http.get('/api/card/detail', params)
}

/**
 * 购买卡片
 * @param {Object} data
 * @param {string} data.game_key - 游戏key
 * @param {string} data.game_sub_key - 游戏子key
 * @param {string} data.cvid - 卡片ID
 */
export function buyCard(data: {
  game_key: string;
  game_sub_key: string;
  cvid: string;
}) {
  return http.post('/api/card/buy', data)
}

// 获取用户信息
export const getUserProfile = (userId: string) => {
  return http.get(`/api/user/${userId}/profile`);
};

// 获取店铺数据
export const getShopData = (params: { 
  user_id: string;
  game_key: string;
  game_sub_key: string;
}) => {
  return http.get('/api/shop', { params });
};

// 获取店铺海报数据
export const getShopPosterData = (params: {
  user_id: string;
  game_key: string;
  game_sub_key: string;
}) => {
  return http.get('/api/shop/poster', { params });
};

// 获取心愿单数据
export const getWishData = (params: { 
  wish_id: string;
}) => {
  return http.get('/api/wish', { params });
};

// 获取我的卡牌列表
export const getCollectList = (params: { 
  collect_key: string;
}) => {
  return http.get('/api/collect/list', { params });
};

// 获取动态分享数据
export const getDynamicShareData = (params: {
  dynamic_content_id: string | number;
  url: string; // 通常分享页需要当前 URL 用于微信 JS-SDK 配置
}) => {
  // 假设后端接口是 /share/dynamic-content
  return http.get<any>('/share/dynamic-content', params);
};


// 运营落地页相关接口
// 获取营销落地页配置
export const getActivityConfig = (params: {
  uuid: string;
}) => {
  // return http.get('/api/market/activities', { params });
  return http.get('/api/market/activities', params);
};

// 获取落地页资源数据
export const getActivityContent = (params: {
  items: string[];
  type: string;
  nonce: string;
}) => {
  return http.post('/api/market/activity/content', params);
};
// 关注
  export const followUser = (params: {
    following_user_id: number;
  }) => {
    return http.post('/api/market/users/follow', params);
  };

  // 取消关注
  export const unfollowUser = (params: {
    following_user_id: number;
  }) => {
    return http.post('/api/market/users/cancelFollow', params);
  };
  
  
  





// 这里可以继续添加其他落地页的接口
// 例如：
// export const getCardDetail = (id: string) => { ... }
// export const getUserProfile = (id: string) => { ... } 